export default function ({ target }) {
  target.setCustomValidity('');
}
